module.exports = __webpack_public_path__ + "media/images/triangle--down-3822ab4f64cbbf3449d44d2d454ef9dc.png";